require("!!/site/packages/javascript/carrot-theme/node_modules/script-loader/addScript.js")(require("!!/site/packages/javascript/carrot-theme/node_modules/raw-loader/index.js!/site/web/app/themes/carrot/bower_components/lity/dist/lity.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script:///site/web/app/themes/carrot/bower_components/lity/dist/lity.js")


//////////////////
// WEBPACK FOOTER
// /site/packages/javascript/carrot-theme/node_modules/script-loader!./bower_components/lity/dist/lity.js
// module id = 35
// module chunks = 1